import React, {useState, useEffect} from 'react';
import {notification, Button, Table} from 'antd';
import Spinner from '../../../../spinner';
import {companyService} from '../../../../../services';
import ModalUploadLegalEntityDocs from '../../../../modals/upload-legal-entity-docs';
import NotificationMessage from "../../../../modals/notification-message";
import {useFetchNotification} from "../../../../../hooks/use-fetch-notification";
import i18n from '../../../../../i18n';


export default function OrdersToShipperCompany() {

  const [needUpdate, setNeedUpdate] = useState(true);
  const [loading, setLoading] = useState(true);
  const [stopListUpdate, setStopListUpdate] = useState(false);

  const [data, setData] = useState(null);

  const [isShowUploads, setShowUploads] = useState(false);

  const [currentOrderId, setCurrentOrderId] = useState(null);
  const [currentLegalEntityId, setCurrentLegalEntityId] = useState(null);
  const [currentLegalEntityOrgFormId, setCurrentLegalEntityOrgFormId] = useState(null);

  const [{notifications}] = useFetchNotification(true);

  useEffect(() => {
    if (!stopListUpdate) {
      setLoading(true);

      companyService
        .getOrdersToShipperCompanyList()
        .then(resp => {
          setData(resp.ordersList);
          setLoading(false);

          setNeedUpdate(false);
          setStopListUpdate(true);
        })
        .catch(errMsg => notification.error(
          {
            message: i18n.t('components.notification.titles.getOrders'),
            description: errMsg
          }));
    }
  }, [needUpdate, stopListUpdate]);

  const handleDownloadBlank = filePath => {
    window.open(filePath);
  };

  const handleShowUpload = record => {
    setCurrentOrderId(record.Id);
    setCurrentLegalEntityId(record.LegalEntity.Id);
    setCurrentLegalEntityOrgFormId(record.LegalEntity.OrgFormId);
    setShowUploads(true);
  };

  const renderButtons = record => {
    if (record.Status.Id === 1) {
      return null;
    }

    if (record.Status.Id === 2) {
      return Object.keys(record.Contracts).map((value) => {
        return (
          <>
            <Button style={{marginLeft: "0px", width: "100%"}} onClick={() => handleDownloadBlank(record.Contracts[value].FilledFile)}
                    size="small" className="small-button typical-btn-green">
              {i18n.t('main.buttons.download')} "{i18n.t(`constants.docTypes.${value}`)}"
            </Button>
            <Button style={{marginLeft: "0px", width: "100%"}} onClick={() => handleDownloadBlank(record.Contracts[value].BlankFile)}
                    size="small" className="small-button typical-btn-blue">
              {i18n.t('main.buttons.downloadOriginal')} "{i18n.t(`constants.docTypes.${value}`)}"
            </Button>
          </>
        );
      });
    }

    if (record.Status.Id === 4 || record.Status.Id === 3) {
      return (
        <Button style={{marginLeft: "0px", width: "100%"}} onClick={() => handleShowUpload(record)} size="small"
                className="small-button typical-btn-green">
          {i18n.t('companyPage.ordersToShipperCompany.buttons.uploadDocs')}
        </Button>
      );
    }

    return null;
  };

  const columns = [
    {
      title: i18n.t('companyPage.ordersToShipperCompany.table.legalEntity.title'),
      key: "legalEntity",
      render: (record) => record.LegalEntity.Name
    },
    {
      title: i18n.t('companyPage.ordersToShipperCompany.table.shipperCompany.title'),
      key: "shipperCompany",
      render: (record) => record.ShipperCompany.Name
    },
    {
      title: i18n.t('companyPage.ordersToShipperCompany.table.status.title'),
      key: "status",
      render: (record) => i18n.t(`constants.contractStatus.${record.Status.Id}`)
    },
    {
      title: i18n.t('companyPage.ordersToShipperCompany.table.dateCreated.title'),
      key: "dateCreated",
      render: (record) => record.DateCreated
    },
    {title: "", key: "actions", render: renderButtons}
  ];

  return (
    <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
      <NotificationMessage notifications={notifications} setStopListUpdate={setStopListUpdate} loading={false}/>

      <Table
        columns={columns}
        dataSource={data}
        locale={{emptyText: i18n.t('main.empty')}}
        rowKey="id"
        size="small"
        pagination={{
          pageSize: 50
        }}
        className="car-park"
        rowClassName={(record, index) => ("car-park-row")
        }
      />
      <ModalUploadLegalEntityDocs isShow={isShowUploads} setIsShow={setShowUploads} orderId={currentOrderId}
                                  setStopListUpdate={setStopListUpdate} orgFormId={currentLegalEntityOrgFormId} legalEntityId={currentLegalEntityId}/>
    </Spinner>
  );
}
